const clientRoutes = [];

export default clientRoutes;
